module.exports = __webpack_public_path__ + "static/media/art-brazil-downtown.c3cc86a4.png";